import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const PreMediaListImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: 'pm_3_2_568_wm', width: 568, height: 378, ratio: 1.5 },
  { screen: Screen.XS, key: 'pm_3_2_768_wm', width: 768, height: 512, ratio: 1.5 },
  { screen: Screen.SM, key: 'pm_3_2_1024_wm', width: 1024, height: 683, ratio: 1.5 },
  { screen: Screen.MD, key: 'pm_8_3_1366_wm', width: 1366, height: 512, ratio: 2.66 },
  { screen: Screen.LG, key: 'pm_8_3_1600_wm', width: 1600, height: 600, ratio: 2.66 },
  { screen: Screen.XL, key: 'pm_8_3_1800_wm', width: 1800, height: 675, ratio: 2.66 },
  { screen: Screen.XXL, key: 'pm_8_3_1920_wm', width: 1920, height: 720, ratio: 2.66 },
];
